export { default as CreateSmartContractShareFormChangeShareHeader } from './CreateSmartContractShareFormChangeShareHeader';
